<template>
  <el-dialog title="批量导入修改房屋面积" :visible.sync="visible" width="500px" @close="resetForm">
    <el-form label-width="100px">
      <el-form-item label="选择文件">
        <el-upload action="" :on-change="handleFileChange" :auto-upload="false"
          :show-file-list="false" accept=".xlsx,.xls">
          <el-button size="small" type="primary">选择Excel文件</el-button>
          <div slot="tip" class="el-upload__tip">{{ fileName || '请选择.xlsx或.xls文件' }}</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="下载模板">
        <el-link type="primary" @click="downloadTemplate">下载房屋面积模板</el-link>
        <div class="template-desc">模板包含当前面积数据，请只修改"修改后面积"列</div>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="importData" :loading="loading">开始导入</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import request from '@/utils/request'

export default {
  name: 'ImportRoomArea',
  data() {
    return { visible: false, loading: false, downloading: false, file: null, fileName: '' }
  },
  methods: {
    open() { this.visible = true },
    handleFileChange(file) { this.file = file.raw; this.fileName = file.name },
    resetForm() { this.file = null; this.fileName = '' },
    async downloadTemplate() {
      if (this.downloading) return
      this.downloading = true
      try {
        const resp = await request({
          url: '/callComponent/download/roomAreaImport/exportTemplate',
          method: 'get',
          params: { communityId: getCommunityId() },
          responseType: 'blob'
        })
        const blob = new Blob([resp.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a'); a.href = url; a.download = 'roomArea.xlsx'; a.click()
        URL.revokeObjectURL(url)
        this.$message.success('模板下载成功')
      } catch (e) {
        this.$message.error('模板下载失败')
      } finally { this.downloading = false }
    },
    async importData() {
      if (!this.file) return this.$message.warning('请选择文件')
      const ext = this.fileName.split('.').pop().toLowerCase()
      if (!['xlsx', 'xls'].includes(ext)) return this.$message.warning('请选择有效的Excel文件')
      if (this.file.size > 10 * 1024 * 1024) return this.$message.warning('文件大小不能超过10MB')
      this.loading = true
      try {
        const fd = new FormData()
        fd.append('uploadFile', this.file)
        fd.append('communityId', getCommunityId())
        const resp = await request({
          url: '/callComponent/upload/roomAreaImport/importData',
          method: 'post',
          data: fd,
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        const res = resp.data
        if (res.code === 0) {
          const d = res.data || {}
          const msg = '总' + d.total + '条，成功' + d.success + '条，失败' + d.fail + '条'
          if (d.fail > 0) { this.$message.warning(msg) } else { this.$message.success(msg) }
          this.$emit('success')
          this.visible = false
        } else {
          this.$message.error(res.msg || '导入失败')
        }
      } catch (e) {
        this.$message.error(e.message || '导入失败')
      } finally { this.loading = false }
    }
  }
}
</script>
<style scoped>
.template-desc { color: #909399; font-size: 12px; margin-top: 4px; }
</style>
